import React from 'react';
import { CopyrightOutlined } from '@ant-design/icons';
import { termsServiceUrl } from '@/lib/locale';
import { useModuleTranslation } from '@/i18n/translation';

const NoLoginFooter = () => {
  const t = useModuleTranslation('common');
  const d = new Date();
  return (
    <div style={{ paddingTop: 10 }}>
      <CopyrightOutlined />
      &nbsp;{d.getFullYear()} Atome{' '}
      <a href={termsServiceUrl} target="_blank" rel="noopener noreferrer">
        {t.ts}
      </a>
    </div>
  );
};

export default NoLoginFooter;
